<template>
  <main id="setting_body">
      <div class="main_top">
        <h1><img src="images/basic/icon/back.svg" onclick="history.back()" class="back">
          환경설정
        </h1>
      </div>
      <div class="div_padding"></div>
     <div class="set_wrapper">
      <div class="menus">
        <span class="group_title">앱 설정</span>
        <table id="ver">
          <tr>
            <th>Static Data</th>
            <td>ver.1.0.0</td>
          </tr>
          <tr>
            <th>Switch On</th>
            <td>
              <div class="toggle-switch">
                <input type="checkbox" id="on">
                <label for="on">
                  <span class="toggle-track"></span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th>Switch Off</th>
            <td>
              <div class="toggle-switch">
                <input type="checkbox" id="off">
                <label for="off">
                  <span class="toggle-track"></span>
                </label>
              </div>
            </td>
          </tr>
          <tr>
            <th>Depth 2 Go</th>
            <td><i class="fas fa-chevron-right"></i></td>
          </tr>
        </table>
      </div>
      <div class="div_padding"></div>
      <div class="menus">
        <span class="group_title">알림 설정</span>
        <table id="ver">
          <tr>
            <th>With Select</th>
            <td>
              <span>오후 12:00   </span> 
              <i class="fas fa-chevron-down"/>
            </td>
          </tr>
          <tr>
            <th>Checkbox Checked</th>
           <td><i class="check fas fa-check-circle fa-2x"></i></td>
          </tr>
          <tr>
            <th>Checkbox</th>
            <td><i class="checked fas fa-check-circle fa-2x"></i></td>
          </tr>
          <tr>
            <th>Menu with subscript
              <P class="subscript">마지막 불러오기 2022.02.22 10:06</P>
            </th>
            <td><i class="fas fa-chevron-right"></i></td>
          </tr>
          <tr>
            <th>Menu with subscript 2
              <p class="subscript">마케팅 정보 수신</p>
            </th>
            <td>
              <span>철회함  </span>
              <i class="fas fa-chevron-right"></i></td>
          </tr>
        </table>
      </div>
    </div>
  </main>
</template>

<script>
export default {

}
</script>

<style scoped>
  .set_wrapper {
    width: 100%;
    padding: 20px 30px;
    overflow-x: hidden;
  }
  #setting_body .wrapper {
  display: flex;
  flex-direction: column;
  height: calc(100% - var(--top) - var(--bottom));
  }
  #setting_body .icon_menu #more_icon div p span {
    color: var(--Main-color);
  }
  #setting_body table {
    font-size: 0.813em;
    width: 100%;
  }
  #setting_body table tr {
    position: relative;
    display: flex;
    align-items: center;
    height: 55px;
    overflow-x: hidden;
  }
  #setting_body table tr::after {
    content: "";
    border-top: 1px solid var(--Gray-Dark);
    width: 300%;
    position: absolute;
    left: 0;
    bottom: 0;
    transform-origin: left bottom;
    transform: scale(0.34);
    opacity: 0.3;
  }
  #setting_body table tr:first-child::before {
    content: "";
    border-bottom: 1px solid var(--Gray-Dark);
    width: 300%;
    position: absolute;
    left: 0;
    top: 8px;
    transform-origin: left top;
    transform: scale(0.34);
    opacity: 0.3;
  }
  #setting_body table tr th {
    font-weight: normal;
    text-align: left;
  }
  #setting_body table tr td {
    color: #9ea3ab;
    text-align: right;
    flex-grow: 1;
  }
  /* resest */
  input{
    -webkit-appearance:none;
    -webkit-border-radius:0;
  }

  .toggle-switch input[type=checkbox]{
    display: none;
    margin: 1px;
  }

  .toggle-track{
    display: inline-block;
    position: relative;
    width: 40px;
    height: 6px;
    border-radius:60px;
    background: #EBEEF1;
    margin: 1px;
  }

  .toggle-track:before{
    content:'';
    display: block;
    position: absolute;
    top: -13.7px;
    left: -8px;
    width: 20px;
    height: 20px; 
    margin: 7px;
    background: #C5C8CF;
    border-radius:100%;
    border:1px solid #C5C8CF;
    transition:left 0.3s;
  }

  .toggle-switch input[type=checkbox]:checked + label .toggle-track{
    background: #F6B581;
  }
  
  .toggle-switch input[type=checkbox]:checked + label .toggle-track:before{
    left: 12px;
    border:1px solid #FF7100;
    background-color: #FF7100;
  }
  .toggle-switch input[type=checkbox]:checked + label .toggle-track:after{
    left: 11px;
  }
  
  .checked {
    color: #FF7100;
  } 

  .check {
    color: #EBEEF1;
  }
  .group_title {
    font-size: 12px;
    color: #9EA3AB;
  }

  .subscript {
    font-size: 12px;
    color: #6F737A;
  }
</style>